import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import { TextField } from "@mui/material";

interface AppDatePickerProps {
  label: string;
  value: Dayjs | null;
  onChange: any;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  fullWidth?: boolean;
  size?: "small" | "medium";
  required?: boolean;
  helperText?: string;
  disabled?: boolean;
  format?: string;
}

export const AppDatePicker: React.FC<AppDatePickerProps> = ({
  label,
  value,
  onChange,
  minDate,
  maxDate,
  fullWidth = true,
  size = "medium",
  required = false,
  helperText,
  disabled = false,
  format = "DD/MM/YYYY",
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={value}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth={fullWidth}
            size={size}
            required={required}
            helperText={helperText}
          />
        )}
      />
    </LocalizationProvider>
  );
};
